import { PlanningViewsResults } from '@src/suite/common/data-models/navigation/planning-views-results';
import { ViewStateRecord } from '@src/suite/common/data-models/records/viewstate-record';

export interface DiscoverState {
    wires: StorytellingWireRecord[];
    selectedImage?: string;
    isLoading: boolean;
    topics: Map<string, StorytellingTopicRecord>;
    storedViewStates: PlanningViewsResults | null;
    currentSelectedViewState: ViewStateRecord | null;
    isAttachToTopicListLoading: boolean;
}

export enum WireTypes {
    RssWire = 0,
    ApWire = 1,
    TwitterWire = 2,
    FTPWire = 4,
}

export enum SrcTypes {
    MainLink = 'main',
    PreviewLink = 'preview',
    ThumbnailLink = 'thumbnail',
}

export enum MediaType {
    PICTURE = 'picture',
    VIDEO = 'video',
}

export type WireFilter = {
    feedType: string;
    feedId: string;
    count: number;
    publishedDate?: string;
    providerId?: string;
    category?: string;
};

export interface WireSearchAPIResponse {
    totalCount: number;
    results: StorytellingWireRecord[];
}
